// extracted by mini-css-extract-plugin
export var container = "_44-0";
export var icon = "_44-1";
export var text = "_44-2";